import { Component, EventEmitter, Output, ChangeDetectorRef, ViewChild, ElementRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../services/api.service';
import { AlertService } from 'src/app/services/alert.service';
import { TranslatePipe } from 'src/app/pipes/translate.pipe';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Reason } from 'src/app/models/close-reason.model';
    
@Component({
  selector: 'app-clone-datamodel',
  templateUrl: './clone-datamodel.component.html',
  styleUrls: ['./clone-datamodel.component.scss']
})
export class CloneDatamodelModalComponent {
  @Input() datamodelId: string;
  public newDatamodelForm: FormGroup;
  public reason = Reason;
  public cloneSpinner: boolean = false;
    
  constructor(
    public activeModal: NgbActiveModal, 
    private apiService: ApiService,
    private fb: FormBuilder,
    public alertService: AlertService,
    public translate: TranslatePipe
  ) {}

  ngOnInit() {
    this.newDatamodelForm = this.fb.group({
      newDatamodelName: ['', Validators.required],
      newDatamodelDisplayName: ['', Validators.required],
      newDatamodelDescription: ['']
    });

  }

  public onCloneDatamodel() {
    this.cloneSpinner = true;
    const body = { ...this.newDatamodelForm.value };

    const payload = {
      new_datamodel_name: body.newDatamodelName,
      new_datamodel_display_name: body.newDatamodelDisplayName,
      original_datamodel_id: this.datamodelId
    };

    this.apiService
      .post('datamodels/clone_datamodel', payload, `Datamodel: '${payload.new_datamodel_name}' successfully created`)
      .subscribe(() => {
        this.cloneSpinner = false;
        this.activeModal.close(this.reason.submitBtn);
        window.location.reload();
      }, (error) => {
        this.cloneSpinner = false;
        console.error('Error cloning datamodel:', error);
      });
}

  close() {
    this.activeModal.dismiss('cancel');
  }

}
